import React, { ComponentType } from "react";
import styles from "./BasicInfoCard.module.scss";
import { SvgIconProps } from "@mui/material/SvgIcon";

interface Props {
  title: string;
  Icon: ComponentType<SvgIconProps>;
  value: string;
}

export const BasicInfoCard = ({ title, Icon, value }: Props) => {
  return (
    <div>
      <p className={styles.title}>{title}</p>
      <div className={styles.value}>
        <Icon />
        <p className={styles.valueTxt}>{value}</p>
      </div>
    </div>
  );
};
